module.exports = __webpack_public_path__ + "img/bottomImg.773262b2.png";